import React from 'react';
import { Helmet } from 'react-helmet-async';
import seoConfig from './seoConfig.json';

const SEOHead = ({ path }) => {
  const pageConfig = seoConfig.pages[path] || seoConfig.pages['/'];
  const global = seoConfig.global;

  return (
    <Helmet>
      <title>{pageConfig.title}</title>
      <meta name="description" content={pageConfig.description} />
      <meta name="keywords" content={pageConfig.keywords} />
      <link rel="canonical" href={pageConfig.canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={global.type} />
      <meta property="og:site_name" content={global.siteName} />
      <meta property="og:title" content={pageConfig.ogTitle} />
      <meta property="og:description" content={pageConfig.ogDescription} />
      <meta property="og:image" content={pageConfig.ogImage || global.defaultImage} />
      <meta property="og:url" content={pageConfig.canonicalUrl} />
      <meta property="og:locale" content={global.locale} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageConfig.ogTitle} />
      <meta name="twitter:description" content={pageConfig.ogDescription} />
      <meta name="twitter:image" content={pageConfig.ogImage || global.defaultImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Teen Challenge Armenia" />
      <meta name="theme-color" content="#1a365d" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(global.organizationSchema)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
